import React from "react";
import { Link } from "react-router-dom";
import BlogHeader from "./BlogHeader";
import BlogFooter from "./BlogFooter";
import ChecklistDownload from "./ChecklistDownload";
import "./Blog.css";
import "./BlogPostSafetyManager.css";
import "./BlogPostRiskAssessment.css";

function BlogPostRiskAssessment() {
  const steps = [
    {
      num: 1,
      time: "약 10분",
      title: "이번 달 작업 목록 먼저 뽑기",
      desc: "공정표나 작업계획서에서 이번 달 예정 작업을 꺼냅니다. 신규 작업, 변경된 작업, 반복 작업을 구분해두면 다음 단계가 빨라집니다.",
      tip: "변경된 작업이 있으면 이전 위험성평가 결과를 그대로 쓰면 안 됩니다. 수시평가 대상입니다.",
      tipType: "warning",
    },
    {
      num: 2,
      time: "약 15분",
      title: "작업별 위험요인 뽑기",
      desc: "각 작업에서 '무엇이 잘못될 수 있는가'를 씁니다. 추락, 끼임, 감전, 화재 등 유해·위험요인을 최소 3개 이상 식별하는 것이 기본입니다.",
      tip: "현장소장이나 작업자에게 한 마디 물어보는 게 가장 빠릅니다. 책상에서 혼자 쓰면 놓치는 게 생깁니다.",
      tipType: "info",
    },
    {
      num: 3,
      time: "약 10분",
      title: "위험성 등급 결정",
      desc: "발생 가능성(빈도) × 피해 중대성으로 등급을 매깁니다. 고·중·저 3단계가 일반적이며, 고위험 작업은 즉시 개선 대책이 필요합니다.",
      tip: null,
      tipType: null,
      matrix: true,
    },
    {
      num: 4,
      time: "약 10분",
      title: "감소대책 기록",
      desc: "등급별로 '어떻게 위험을 줄일 것인가'를 씁니다. 제거 → 대체 → 공학적 조치 → 관리적 조치 → 보호구 순으로 가장 효과적인 방법을 우선합니다.",
      tip: "\"안전화 착용\"만 쓰면 감사 시 지적받습니다. 구체적인 조치(작업 발판 설치, 안전난간 설치 등)를 써야 합니다.",
      tipType: "danger",
    },
    {
      num: 5,
      time: "약 5분",
      title: "서명 받고 보관",
      desc: "경영책임자 또는 안전보건관리책임자 서명을 받고, 작업자에게 공유한 기록을 남깁니다. 보관 기간은 최소 3년입니다.",
      tip: "공유 기록이 없으면 교육은 했어도 증빙이 안 됩니다. 단체톡 공지 캡처도 증빙이 됩니다.",
      tipType: "info",
    },
  ];

  return (
    <div className="blog-wrap">
      <BlogHeader />
      <div className="blog-post-wrap">

        <div className="blog-post-header">
          <div className="blog-breadcrumb">
            <a href="/">현장통</a> › <Link to="/blog">현장가이드</Link> › <span>현장 운영</span>
          </div>
          <h1>이번 달 위험성평가,<br />빠진 항목 없이 끝내는 5단계</h1>
          <div className="blog-post-meta">
            <span className="meta-tag" style={{ background: "#d1fae5", color: "#065f46" }}>현장 운영</span>
            <span className="meta-tag" style={{ background: "#d1fae5", color: "#065f46" }}>안전관리자</span>
            <span>2026.06.05</span>
            <span>읽기 3분</span>
          </div>
        </div>

        <article className="sm-article">

          {/* Hook */}
          <div className="ra-hook">
            <p>매달 돌아오는 위험성평가.</p>
            <p>뭘 어디서부터 해야 할지 막막하거나, 지난달 양식 복사해서 날짜만 바꾸게 되는 분들 많으실 겁니다.</p>
            <p>그게 통하던 시절도 있었는데, 이제는 아닙니다.</p>
          </div>

          <div className="sm-insight">
            <div className="sm-insight-label">핵심 포인트</div>
            <p>위험성평가를 "했다"는 것과 "제대로 했다"는 건 다릅니다.<br />감사가 나오면 그 차이가 드러납니다.</p>
          </div>

          <p>5단계로 정리해드립니다. 오늘 바로 쓸 수 있습니다.</p>

          {/* Steps */}
          <div className="ra-steps">
            {steps.map((step) => (
              <div className="ra-step" key={step.num}>
                <div className="ra-step-header">
                  <div className="ra-step-num">{step.num}</div>
                  <div className="ra-step-title">{step.title}</div>
                  <div className="ra-step-time">{step.time}</div>
                </div>
                <div className="ra-step-body">
                  <p>{step.desc}</p>

                  {step.matrix && (
                    <div className="ra-matrix">
                      <div className="ra-matrix-title">위험성 등급 판단표</div>
                      <table className="ra-matrix-table">
                        <thead>
                          <tr>
                            <th>가능성 ↓ / 중대성 →</th>
                            <th>경미</th>
                            <th>보통</th>
                            <th>심각</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><strong>낮음</strong></td>
                            <td className="ra-low">저</td>
                            <td className="ra-low">저</td>
                            <td className="ra-mid">중</td>
                          </tr>
                          <tr>
                            <td><strong>보통</strong></td>
                            <td className="ra-low">저</td>
                            <td className="ra-mid">중</td>
                            <td className="ra-high">고</td>
                          </tr>
                          <tr>
                            <td><strong>높음</strong></td>
                            <td className="ra-mid">중</td>
                            <td className="ra-high">고</td>
                            <td className="ra-high">고</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}

                  {step.tip && (
                    <div className={`ra-tip ra-tip-${step.tipType}`}>
                      <span className="ra-tip-icon">
                        {step.tipType === "warning" && "⚠️"}
                        {step.tipType === "info" && "💡"}
                        {step.tipType === "danger" && "🚨"}
                      </span>
                      {step.tip}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* 자주 빠지는 것들 */}
          <h2 className="sm-h2">자주 빠지는 항목 3가지</h2>

          <p>5단계를 다 거쳐도 이 세 가지를 놓치면 감사 시 지적받습니다.</p>

          <div className="ra-miss-list">
            <div className="ra-miss-item">
              <div className="ra-miss-num">1</div>
              <div>
                <div className="ra-miss-title">수시평가 누락</div>
                <div className="ra-miss-desc">작업 방법이 바뀌었거나 새로운 장비가 투입됐을 때는 정기평가와 별개로 수시평가를 해야 합니다. 공정 변경이 생겼는데 기존 평가서를 그대로 쓰면 안 됩니다.</div>
              </div>
            </div>
            <div className="ra-miss-item">
              <div className="ra-miss-num">2</div>
              <div>
                <div className="ra-miss-title">협력업체 작업 누락</div>
                <div className="ra-miss-desc">직영 인력 작업만 평가하고 협력업체 작업을 빠뜨리는 경우가 많습니다. 도급 작업도 원청이 위험성평가를 해야 합니다.</div>
              </div>
            </div>
            <div className="ra-miss-item">
              <div className="ra-miss-num">3</div>
              <div>
                <div className="ra-miss-title">근로자 참여 기록 없음</div>
                <div className="ra-miss-desc">위험성평가는 근로자 의견을 반영해야 합니다. 참여했다는 기록(서명, 회의록 등)이 없으면 절차를 지키지 않은 것으로 판단됩니다.</div>
              </div>
            </div>
          </div>

          {/* 시간 단축 팁 */}
          <h2 className="sm-h2">한 번 잘 만들어두면 다음 달이 빠릅니다</h2>

          <p>위험성평가가 매달 오래 걸리는 이유 중 하나는 양식을 처음부터 다시 시작하기 때문입니다.</p>
          <p>반복 작업의 평가 결과는 템플릿으로 저장해두고, 변경된 부분만 수정하면 됩니다. 현장통에서는 이전 평가 결과를 불러와서 수정하는 방식으로 쓸 수 있습니다.</p>

          {/* CTA */}
          <div className="sm-cta">
            <div className="sm-cta-question">위험성평가 양식이 필요하신가요?</div>
            <p>현장에서 바로 쓸 수 있는 위험성평가 6단계 체크리스트를<br />무료로 드립니다. 변경 시 수시 재평가 등 자주 빠지는 항목까지 정리했습니다.</p>
            <div className="sm-cta-buttons">
              <ChecklistDownload
                checklistTitle="위험성평가 6단계 체크리스트"
                pdf="/checklists/risk-assessment-checklist.pdf"
                fileName="현장통_위험성평가_6단계_체크리스트.pdf"
                className="sm-cta-btn primary"
                label="무료 체크리스트 받기 →"
              />
              <a href="/#contact" className="sm-cta-btn secondary">
                무료체험 문의하기
              </a>
            </div>
          </div>

          {/* Tags */}
          <div className="blog-tags">
            {["#위험성평가", "#안전관리자", "#건설현장안전", "#위험성평가방법", "#안전보건", "#현장통", "#중대재해처벌법", "#안전관리앱"].map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>

          {/* Related */}
          <div className="blog-related">
            <h3>다음으로 읽으면 좋은 글</h3>
            <div className="related-grid">
              <Link to="/blog/safety-manager-paperwork" className="related-card">
                <div className="related-card-tag">현장 운영</div>
                <div className="related-card-title">안전관리자가 서류에 치이는 진짜 이유 — 그리고 하루를 되찾는 법</div>
              </Link>
              <Link to="/blog/serious-accident-law" className="related-card">
                <div className="related-card-tag">법규 가이드</div>
                <div className="related-card-title">중대재해처벌법 건설사 실무 대응 가이드 [2026년]</div>
              </Link>
              <Link to="/blog/tbm-no-record" className="related-card">
                <div className="related-card-tag">현장 운영</div>
                <div className="related-card-title">TBM 매일 하는데 왜 기록이 없나 — 현장소장의 현실</div>
              </Link>
            </div>
          </div>

        </article>

        <BlogFooter />

      </div>
    </div>
  );
}

export default BlogPostRiskAssessment;
